import { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { useAuthStore } from '../stores/authStore'
import { useSessionTimeout } from '../hooks/useSessionTimeout'
import SessionExpiredModal from './SessionExpiredModal'
import api from '../services/api'

function ProtectedRoute({ children }) {
  const { isAuthenticated, user, setUserSetupCompleted } = useAuthStore()
  const location = useLocation()

  // Als user zegt "setup niet voltooid", controleer of Master DNA wél vol is (dan hoeft setup niet meer)
  const { data: setupStatus, isLoading: setupStatusLoading } = useQuery({
    queryKey: ['setup', 'status'],
    queryFn: async () => {
      const res = await api.get('/setup/status')
      return res.data
    },
    enabled: !!user && !user?.is_setup_completed && location.pathname !== '/setup',
    staleTime: 60 * 1000,
  })

  const effectiveSetupCompleted = user?.is_setup_completed || setupStatus?.is_setup_completed === true

  // Sync store: als API zegt voltooid, bijwerken zodat we niet elke keer hoeven te fetchen
  useEffect(() => {
    if (setupStatus?.is_setup_completed === true && user && !user.is_setup_completed && typeof setUserSetupCompleted === 'function') {
      setUserSetupCompleted(true)
    }
  }, [setupStatus?.is_setup_completed, user, setUserSetupCompleted])

  // Activeer session timeout tracking
  const { showExpiredModal, handleLogout } = useSessionTimeout()
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  // Terwijl we setup-status ophalen (als user nog niet "completed" heeft), niet redirecten om flitsen te voorkomen
  if (!!user && !user.is_setup_completed && !effectiveSetupCompleted && setupStatusLoading) {
    return (
      <div className="flex items-center justify-center min-h-[200px]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
      </div>
    )
  }
  
  // Redirect naar setup alleen als instellingen echt niet voltooid zijn (wizard noch Master DNA)
  if (!effectiveSetupCompleted && location.pathname !== '/setup') {
    return <Navigate to="/setup" replace />
  }
  
  return (
    <>
      {children}
      <SessionExpiredModal isOpen={showExpiredModal} onClose={handleLogout} />
    </>
  )
}

export default ProtectedRoute
